window.addEventListener('DOMContentLoaded', () =>{
    var divWinespecs = document.querySelector(".wine-specs");
    const childNodeWidth = parseFloat(window.getComputedStyle(divWinespecs).width)

const result = document.evaluate(
  "//div[@class='wine-specs']/parent::div",
  document,
  null,
  XPathResult.FIRST_ORDERED_NODE_TYPE,
  null
);    
const node = result.singleNodeValue;
console.log(node);

const parentDivWidth = parseFloat(window.getComputedStyle(node).width)

console.log(parentDivWidth - childNodeWidth)

if ((parentDivWidth - childNodeWidth) != 1){
    const sub = parentDivWidth - childNodeWidth;
    divWinespecs.style.marginLeft = `${sub/2}px`;
    divWinespecs.style.marginRight = `${sub/2}px`;
};

});





window.addEventListener('resize', () => {
    var divWinespecs = document.querySelector(".wine-specs");
    const childNodeWidth = parseFloat(window.getComputedStyle(divWinespecs).width)

const result = document.evaluate(
  "//div[@class='wine-specs']/parent::div",
  document,
  null,
  XPathResult.FIRST_ORDERED_NODE_TYPE,
  null
);    
const node = result.singleNodeValue;
console.log(node);

const parentDivWidth = parseFloat(window.getComputedStyle(node).width)

console.log(parentDivWidth - childNodeWidth)

if ((parentDivWidth - childNodeWidth) != 1){
    const sub = parentDivWidth - childNodeWidth;
    divWinespecs.style.marginLeft = `${sub/2}px`;
    divWinespecs.style.marginRight = `${sub/2}px`;
};


});